/**
 * @file 新闻详情页
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';

import useNewsDetailStore from './NewsDetailHooks';

const News: React.FC = () => {
    const {
        title,
        pubTime,
        pv,
        content,
        preNews,
        nextNews,
        relations
    } = useNewsDetailStore();

    return (
        <div className="page paddle-news-detail-page">
            <Header />
            <div className="paddle-news-detail-page-container">

                <div className="ai-newscdetail">
                    <div className="ai-newscdetail-main">
                        <div className="ai-newscdetail-title">
                            {title}
                        </div>

                        <div className="ai-newscdetail-info-container">
                            <span
                                className="ai-newscdetail-time">
                                发布日期：{pubTime}
                            </span>
                            <span>浏览量：{pv}次</span>
                            <div
                                className="ai-newscdetail-content"
                                dangerouslySetInnerHTML={{__html: content}}
                            />
                            <div className="ai-newscdetail-pagination">
                                {
                                    !!preNews
                                    && <div className="ai-newscdetail-previous">
                                        上一篇：<a href={preNews.link}>
                                        {preNews.title}
                                    </a>
                                    </div>
                                }
                                {
                                    !!nextNews
                                    && <div className="ai-newscdetail-next">
                                        下一篇：<a href={nextNews.link}>
                                        {nextNews.title}
                                    </a>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="ai-newscdetail-recommend">
                        <div className="ai-newscdetail-recommend-title">相关动态</div>
                        {relations.map(news => (
                            <div
                                className="ai-newscdetail-recommend-item"
                                key={news.id}
                            >
                                <a href={news.link}>{news.title}</a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default News;
